import type { NodeType } from './utils'

export const NODE_META: Record<NodeType, { titleHint: string }> = {
  cash_server: { titleHint: 'Кассовый сервер' },
  cm_server: { titleHint: 'Сервер СМ' },
  mikrotik: { titleHint: 'MikroTik' },
  integration: { titleHint: 'Модуль интеграции' },
  egais_utm: { titleHint: 'ЕГАИС УТМ' },
  chz: { titleHint: 'Честный Знак' },
  unknown: { titleHint: 'Узел' },
}
